import { alpha, Box, Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch";

const MIN_SCALE = 1;
const MAX_SCALE = 3;

interface ZoomableImageProps {
  src: string;
  alt: string;
}

function ZoomControls() {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        position: "absolute",
        bottom: (theme) => theme.spacing(4),
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.9),
        borderRadius: 2,
        padding: 2,
      }}
    >
      <IconButton
        aria-label="Zoom out"
        iconType="minus"
        size="xSmall"
        variant="outlined"
        onClick={() => {
          zoomOut();
        }}
      />
      <IconButton
        aria-label="Reset zoom"
        iconType="refresh"
        size="xSmall"
        variant="outlined"
        onClick={() => {
          resetTransform();
        }}
      />
      <IconButton
        aria-label="Zoom in"
        iconType="plus"
        size="xSmall"
        variant="outlined"
        onClick={() => {
          zoomIn();
        }}
      />
    </Stack>
  );
}

export function ZoomableImage(props: ZoomableImageProps) {
  const { src, alt } = props;

  return (
    <TransformWrapper
      centerZoomedOut
      initialScale={MIN_SCALE}
      minScale={MIN_SCALE}
      maxScale={MAX_SCALE}
      doubleClick={{ mode: "toggle", step: 2 }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          border: (theme) => `1px solid ${theme.palette.grey[400]}`,
        }}
      >
        <TransformComponent
          wrapperStyle={{ width: "100%", height: "100%" }}
          contentStyle={{ width: "100%", height: "100%" }}
        >
          <Box
            component="img"
            draggable={false}
            src={src}
            alt={alt}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </TransformComponent>
        <ZoomControls />
      </Box>
    </TransformWrapper>
  );
}
